import { Classes, HTMLSelect } from "@blueprintjs/core";
import styled, { css } from "styled-components";

export const htmlSelectStyles = css<{ $small?: boolean }>`
  .${Classes.ICON} {
    top: ${({ $small }) => ($small ? "4px" : "7px")};
    right: 7px;
  }

  &:not(.${Classes.MINIMAL}) {
    select {
      box-shadow: ${({ theme }) => theme.boxShadow.BUTTON};
    }
  }

  &.${Classes.DISABLED} {
    ${({ theme }) => theme.disabledState}

    select {
      background-color: ${({ theme }) => theme.backgroundColor.DEFAULT};
    }
  }

  select {
    ${({ $small, theme }) =>
      $small &&
      css`
        height: 24px;
        padding: 0 8px;

        font-size: ${theme.fontSize.SMALL};
        line-height: 14px;
      `}

    color: ${({ theme }) => theme.fontColor.DEFAULT};

    background-color: ${({ theme }) => theme.backgroundColor.DEFAULT};

    background-image: none;

    transition: background-color ${({ theme }) => theme.animation.duration}
      ${({ theme }) => theme.animation.easing};

    &:hover {
      background-color: ${({ theme }) => theme.hoverColor};
      box-shadow: ${({ theme }) => theme.boxShadow.BUTTON};
    }

    &:active {
      background-color: ${({ theme }) => theme.activeColor};
    }
  }
`;

export const HexHTMLSelect = styled(HTMLSelect)<{ $small?: boolean }>`
  ${htmlSelectStyles}
`;
